import { useModalContext } from "shared/core/state/ModalContext/ModalContext";
import Modals from "core/enums/modals.enum";
import { useUserContext } from "core/state/UserContext/UserContext";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ReactComponent as CloseCircle } from "@icons/close-circle.svg";
import { ReactComponent as Close } from "@icons/close.svg";
import PageModal from "UIPalette/PageModal/PageModal";
import useIsMobile from "shared/core/hooks/useIsMobile";
import { trackEvents } from "core/monitoring/Events";
import { EventNames } from "core/monitoring/types/enums";

export default function MoodSupportModal() {
  const { t } = useTranslation();
  const { isVisible, hide } = useModalContext(Modals.MoodSupport);
  const { user } = useUserContext();
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const handleSkip = () => {
    trackEvents(EventNames.MOOD_SUPPORT_MODAL_SKIP);
    hide();
    navigate("/mood-insights");
  };

  const handleContactUs = () => {
    trackEvents(EventNames.MOOD_SUPPORT_MODAL_CONTACT_US);
    hide();
    navigate("/contact-us");
  };

  const handleClose = () => {
    trackEvents(EventNames.MOOD_SUPPORT_MODAL_CLOSE);
    hide();
  };

  const backIcon = isMobile ? Close : CloseCircle;

  if (!isVisible) {
    return null;
  }

  return (
    <PageModal
      variant="red"
      backIcon={backIcon}
      onClose={handleClose}
      backTitle="Close"
      nextTitle="Skip"
      onNext={handleSkip}
      primaryCta={{ title: t("moodSupport.contactUs"), onClick: handleContactUs }}
      textCta={{ title: t("moodSupport.skip"), onClick: handleSkip }}
    >
      <div data-testid="mood-support-modal" className="h-full lg:h-auto flex flex-col gap-10 justify-center text-center lg:justify-start">
        <h2 className="!pb-0">{t("moodSupport.heading", { name: user?.forenames ? ` ${user?.forenames}` : "" })}</h2>
        <p>{t("moodSupport.message")}</p>
      </div>
    </PageModal>
  );
}
